const PAYMENTS_URL = `${process.env.API_V4_HOST}/_exclusive/payments`;

/**
 * @param {object} $axios
 * @param {String} invoiceId
 * @returns {Promise}
 * https://blueprint.bukalapak.io/exclusive/t/payments~payment~billings~get~exclusive~payments~billings~invoice~id
 */
export const getPaymentsBillings = ($axios, invoiceId) => $axios.$get(`${PAYMENTS_URL}/billings/${invoiceId}`);
